import { APP_CONST } from "../constants/App.const";

export async function fetchWithAuth(
  input: RequestInfo,
  init?: RequestInit,
  logout?: () => void
): Promise<Response> {
  const token = localStorage.getItem(APP_CONST.USER_TOKEN);

  const headers = new Headers(init?.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
  }

  const modifiedInit: RequestInit = {
    ...init,
    headers,
  };
  const response = await fetch(input, modifiedInit);

  // handle unauthorized
  if (response.status === 401 && logout) {
    logout();
  }

  return response;

}
